import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "@/locales/en.json";

const STORAGE_KEY = "nexus_lang";

const savedLang = localStorage.getItem(STORAGE_KEY);

i18n.use(initReactI18next).init({
  resources: { en: { translation: en } },
  lng: savedLang || "en",
  fallbackLng: "en",
  interpolation: { escapeValue: false },
  showSupportNotice: false,
});

i18n.on("languageChanged", (lng) => {
  localStorage.setItem(STORAGE_KEY, lng);
});

export default i18n;
